var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid grid--full-height", attrs: { id: "login-layout" } },
    [
      _c(
        "div",
        {
          staticClass:
            "grid__cell grid grid--column grid--jc-middle grid--ai-middle"
        },
        [
          _c("div", { staticClass: "login__wrapper" }, [
            _vm.showMaLogo
              ? _c("img", {
                  staticClass: "mg mg--b-2",
                  attrs: { src: require("@/assets/logo_ma_orange.svg") }
                })
              : _vm._e(),
            !_vm.showMaLogo
              ? _c("img", {
                  staticClass: "mg mg--b-2",
                  staticStyle: { width: "160px" },
                  attrs: { src: require("@/assets/allianz_blue.png") }
                })
              : _vm._e(),
            _c("p", { staticClass: "headline-large mg mg--b-1 gray" }, [
              _vm._v(_vm._s(_vm.loginTitle))
            ]),
            _c("p", { staticClass: "text-medium mg mg--b-8 gray" }, [
              _vm._v(_vm._s(_vm.$t("login.text")))
            ]),
            _c("div", { staticClass: "grid" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.handleEnter($event)
                    }
                  }
                },
                [
                  _c("ma-input-text", {
                    attrs: {
                      name: "username",
                      type: "text",
                      col: "4",
                      icon: "ico-donnes-du-dossier",
                      literal: _vm.$t("login.inputs.username"),
                      selectedValue: "",
                      autocomplete: "username"
                    },
                    model: {
                      value: _vm.user.username,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "username", $$v)
                      },
                      expression: "user.username"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      name: "password",
                      type: "password",
                      col: "4",
                      icon: "ico-donnes-du-dossier",
                      literal: _vm.$t("login.inputs.password"),
                      autocomplete: "current-password"
                    },
                    model: {
                      value: _vm.user.password,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "password", $$v)
                      },
                      expression: "user.password"
                    }
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "mainBlue mg mg--t-7",
                      attrs: { disabled: _vm.disableLoginButton }
                    },
                    [_vm._v(_vm._s(_vm.$t("login.login")))]
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "grid__cell" }, [
        _c("div", {
          staticClass: "login__bg",
          style: {
            backgroundImage:
              "url(" +
              require("@/assets/images/views/login/login_bg_1x.png") +
              ")"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }